<template>
  <v-container id="club-forms" fluid>
    <base-material-card color="#ac8a2e" icon="mdi-soccer" inline class="px-5 py-3" title="Clubes">
      <template v-slot:after-title>
        <v-dialog v-model="dialog" persistent max-width="600px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="#ac8a2e" dark icon v-bind="attrs" v-on="on">
              <v-icon large color="#ac8a2e">
                mdi-soccer
              </v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <validation-observer v-slot="{ handleSubmit }">
                  <form id="altaclub" @submit.prevent="handleSubmit(validateForm)">
                    <v-row align="center" justify="center">
                      <v-col cols="12">
                        <validation-provider v-slot="{ errors }" name="club" rules="max:20">
                          <v-text-field v-model="dataForm.descripcion" color="#ac8a2e" :error-messages="errors" name="input-6-1" label="Club" />
                        </validation-provider>
                      </v-col>
                      <v-col cols="12">
                        <validation-provider v-slot="{ errors }" name="liga" rules="required">
                          <v-select v-model="dataForm.liga_id" color="#ac8a2e" :error-messages="errors" label="Liga" item-value="id" item-text="descripcion" :items="ligas">
                            <template v-slot:item="{ attrs, item, on }">
                              <v-list-item v-bind="attrs" active-class="secondary elevation-4 white--text" class="v-sheet" elevation="0" v-on="on">
                                <v-list-item-content>
                                  <v-list-item-title v-text="item.descripcion" />
                                </v-list-item-content>
                              </v-list-item>
                            </template>
                          </v-select>
                        </validation-provider>
                      </v-col>
                    </v-row>
                  </form>
                </validation-observer>
                <v-card-actions>
                  <v-spacer />
                  <v-btn color="blue darken-1" text @click="close">
                    Cancelar
                  </v-btn>
                  <v-btn color="blue darken-1" text form="altaclub" type="submit" @click="dialog = false">
                    Guardar
                  </v-btn>
                </v-card-actions>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
      </template>
      <v-row align="end" justify="end">
        <v-col cols="5">
          <v-text-field v-model="search" append-icon="mdi-magnify" class="ml-auto" color="gold" label="Buscar" hide-details single-line style="max-width: 250px;" />
        </v-col>
      </v-row>
      <v-divider class="mt-3" />

      <v-data-table
        :headers="headers"
        :items="clubes"
        :search.sync="search"
        :sort-by="['name', 'office']"
        :sort-desc="[false, true]"
        multi-sort
      >
        <template v-if="$can('M_parametros')" v-slot:[`item.actions`]="{ item }">
          <v-tooltip content-class="top" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click="editItem(item)">
                mdi-pencil
              </v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip content-class="top" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click="deleteItem(item)">
                mdi-delete
              </v-icon>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </base-material-card>
    <confirm ref="confirm" />
  </v-container>
</template>

<script>
  import confirm from '../../../components/confirm'

  export default {
    components: {
      confirm,
    },
    data () {
      return {
        dialog: false,
        search: undefined,
        headers: [
          {
            text: 'Club',
            sortable: false,
            value: 'descripcion',
          },
          { text: 'Liga', value: 'liga.descripcion' },
          { text: 'Acciones', value: 'actions', sortable: false, align: 'end' },
        ],
        clubes: [],
        editedIndex: -1,
        ligas: [],
        dataForm: {
          id: '',
          liga_id: '',
          descripcion: '',
          liga: {
            id: '',
            descripcion: '',
          },
        },
      }
    },
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nuevo club' : 'Editar club'
      },
      mode () {
        return this.editedIndex === -1 ? 'new' : 'edit'
      },
    },
    created () {
      this.getClubes()
      this.getLigas()
    },
    methods: {

      getClubes: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/club_get' }).then(response => { this.clubes = response })
        /*
        this.$store.commit('loaderOn', 1)
        await this.$http.get('/api/club_get',
                             {
                               headers: { Authorization: 'Bearer ' + this.$store.state.token },
                             },
        ).then(response => {
          this.clubes = response.data
        })
        this.$store.commit('loaderOff')
        */
      },

      getLigas: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/liga_get' }).then(response => { this.ligas = response })
        /*
        this.$store.commit('loaderOn', 1)
        await this.$http.get('/api/liga_get',
                             {
                               headers: { Authorization: 'Bearer ' + this.$store.state.token },
                             },
        ).then(response => {
          this.ligas = response.data
        })
        this.$store.commit('loaderOff')
        */
      },

      editItem (item) {
        this.editedIndex = this.clubes.indexOf(item)
        this.dataForm = Object.assign({}, item)
        this.dialog = true
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      deleteItem (item) {
        this.$refs.confirm.open('Alerta', 'Está seguro de eliminar el registro ?', { color: 'red' }).then((confirm) => {
          if (confirm) {
            this.deleteItemConfirm(item)
          }
        })
      },

      deleteItemConfirm: async function (item) {
        await this.$http.delete('/api/club_delete/' + item.id,
                                {
                                  headers: { Authorization: 'Bearer ' + this.$store.state.token },
                                },
        ).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Club eliminado exitosamente'] })
        }).catch(error => {
          if (error.response.data.errors) {
            this.$store.commit('toast/show', { tipo: 'error', messages: error.response.data.errors })
          } else {
            this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
          }
        })
        this.getClubes()
        this.getLigas()
      },

      validateForm (scope) {
        this.enviarClub()
      },

      enviarClub: async function () {
        const method = (this.mode === 'new') ? 'post' : 'put'
        await this.$http({
          method: method,
          url: '/api/club_agregar',
          data: {
            ...this.dataForm,
          },
          headers: { Authorization: 'Bearer ' + this.$store.state.token },
        }).then(response => {
          this.getClubes()
          this.getLigas()
          this.close()
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Alta de club exitosa'] })
        }).catch(error => {
          this.$store.commit('toast/show', { tipo: 'error', messages: error.response.data.errors })
        })
      },
    },
  }
</script>
